import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
import { default as React, useState } from 'react';
import { Platform } from 'react-native';
import Toast from 'react-native-root-toast';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { useCheckAuth } from '@/utils/checkAuth';
import { useDeleteAccessibility } from '../hooks/useDeleteAccessibility';
import DeleteBottomSheet from '../modals/DeleteBottomSheet';
import * as S from './PlaceDetailFeedbackSection.style';
export const PlaceDetailFeedbackSection = ({ placeId, accessibility, }) => {
    const deletePlaceAccessibility = useDeleteAccessibility('place', placeId, accessibility);
    const deleteBuildingAccessibility = useDeleteAccessibility('building', placeId, accessibility);
    const [isPlaceDeleteModalVisible, setIsPlaceDeleteModalVisible] = useState(false);
    const [isBuildingDeleteModalVisible, setIsBuildingDeleteModalVisible] = useState(false);
    const checkAuth = useCheckAuth();
    const showPlaceDeleteConfirmBottomSheet = () => {
        if (Platform.OS === 'web') {
            Toast.show('준비 중입니다 💪', {
                duration: Toast.durations.SHORT,
                position: Toast.positions.BOTTOM,
            });
            return;
        }
        checkAuth(() => {
            setIsPlaceDeleteModalVisible(true);
        });
    };
    const showBuildingDeleteConfirmBottomSheet = () => {
        if (Platform.OS === 'web') {
            Toast.show('준비 중입니다 💪', {
                duration: Toast.durations.SHORT,
                position: Toast.positions.BOTTOM,
            });
            return;
        }
        checkAuth(() => {
            setIsBuildingDeleteModalVisible(true);
        });
    };
    if (!deletePlaceAccessibility.isDeletable &&
        !deleteBuildingAccessibility.isDeletable) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(SectionSeparator, {}), _jsxs(S.PlaceDetailFeedbackSection, { children: [_jsx(S.SectionTitle, { children: "\uC774 \uC815\uBCF4\uB97C \uC0AD\uC81C\uD560\uAE4C\uC694?" }), deletePlaceAccessibility.isDeletable && (_jsx(S.Buttons, { children: _jsx(S.DeleteButton, { elementName: "place_detail_delete_place_button", onPress: showPlaceDeleteConfirmBottomSheet, children: _jsx(S.DeleteButtonText, { children: "\uC7A5\uC18C \uC815\uBCF4 \uC0AD\uC81C\uD558\uAE30" }) }) })), deleteBuildingAccessibility.isDeletable && (_jsx(S.Buttons, { children: _jsx(S.DeleteButton, { elementName: "place_detail_delete_building_button", style: { marginTop: 16 }, onPress: showBuildingDeleteConfirmBottomSheet, children: _jsx(S.DeleteButtonText, { children: "\uAC74\uBB3C \uC815\uBCF4 \uC0AD\uC81C\uD558\uAE30" }) }) })), _jsx(DeleteBottomSheet, { isVisible: isPlaceDeleteModalVisible, confirmText: '이 장소의 계단정보와 댓글이 모두 삭제됩니다. 정말 삭제할까요?', onPressCancelButton: () => setIsPlaceDeleteModalVisible(false), onPressConfirmButton: () => {
                            deletePlaceAccessibility.mutate();
                            setIsPlaceDeleteModalVisible(false);
                        } }), _jsx(DeleteBottomSheet, { isVisible: isBuildingDeleteModalVisible, confirmText: '이 건물의 계단정보와 댓글이 모두 삭제됩니다. 정말 삭제할까요?', onPressCancelButton: () => setIsBuildingDeleteModalVisible(false), onPressConfirmButton: () => {
                            deleteBuildingAccessibility.mutate();
                            setIsBuildingDeleteModalVisible(false);
                        } })] })] }));
};
const SectionSeparator = styled.View `
  height: 6px;
  background-color: ${color.gray5};
`;
